<template>
  <div class="categories-select-field">
    <v-select
      :value="value"
      :items="roles"
      attach
      outlined
      chips
      deletable-chips
      small-chips
      :label="label"
      :hint="hint"
      persistent-hint
      multiple
      item-text="title"
      item-value="id"
      :loading="loading || rolesLoading"
      :disabled="loading || rolesLoading"
      :rules="rules.requiredArray"
      :error-messages="errorMessages"
      @input="syncValue"
    ></v-select>
  </div>
</template>

<script>
  import { isEmpty } from 'lodash'
  import rules from '@/mixins/rules'
  import snackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'RolesSelectFields',
    emits: [
      'select-roles',
    ],
    components: { },
    mixins: [rules, snackbarMessage],
    props: {
      label: {
        type: String,
        default: 'Должность (роли)',
      },
      value: {
        type: Array,
        default: () => [],
      },
      emptyText: {
        type: String,
        default: null,
      },
      errorMessages: {
        type: [String, Array],
        default: () => [],
      },
      loading: Boolean,
      disabled: Boolean,
    },
    data () {
      return {
        roles: [],
        rolesLoading: false,
      }
    },
    computed: {
      showEmptyText () {
        return this.emptyText && isEmpty(this.value) && !this.loading && !this.rolesLoading
      },
      hint () {
        return this.showEmptyText ? this.emptyText : null
      },
      selectedRoles () {
        return this.roles.filter((ell) => this.value.includes(ell.id))
      },
    },
    watch: {
      selectedRoles (val) {
        this.$emit('select-roles', val)
      },
    },
    async created () {
      this.rolesLoading = true
      try {
        this.roles = await this.$store.dispatch('roles/fetchAvailableRoleList')
      } catch (e) {
        this.showErrorFromResponse(e)
      } finally {
        this.rolesLoading = false
      }
    },
    methods: {
      syncValue (value) {
        this.search = ''
        this.$emit('input', value)
      },
    },
  }
</script>

<style lang="less" scoped>
.categories-select-field {
  ::v-deep {
    .v-text-field .v-label--active {
      transform: translateY(-25px) scale(0.75);
    }
  }
}
</style>
